export default "/public/app-main/static/image/6a773f6d0179d63b9cf403bf92a04b98.png";